import React, { Fragment, useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { connect } from "react-redux";
import Styles from "../DetailParcelle.scss";

const DataProprioBND = (props) => {
   const [isLoading, setIsLoading] = useState(false);
   const [asData, setAsData] = useState(false);
   const [items, setItems] = useState([]);

   useEffect(() => {
      props.detailKeyPar ? fetchData() : null;
   }, [props.detailKeyPar]);

   useEffect(() => {
      items.length > 0 ? setAsData(true) : setAsData(false);
   }, [items]);

   const fetchData = () => {
      setIsLoading(true);
      const params = {
         key_parcelles: [props.detailKeyPar],
      };
      axios
         .post("/Api/geodata/vmap/parcelle/proprietaire_bnd", params)
         .then((result) => {
            setItems(result.data);
            setIsLoading(false);
         })
         .catch((err) => {
            console.log(err);
         });
   };

   const renderItems = (item, index) => {
      return (
         <tr key={index}>
            <td>{item.dnulot}</td>
            <td>
               <div className={"flex flex-column"}>
                  <div style={{ whiteSpace: "pre-line" }}>{item?.nom}</div>
                  <div
                     style={{
                        fontSize: "0.58rem",
                        color: "rgb(164,164,164)",
                        marginTop: "5px",
                     }}
                  >
                     {item?.indivi}
                  </div>
               </div>
            </td>
            <td colSpan={2}>{item.date_acte}</td>
            <td className={"text-center"}>{item.dcntlo}</td>
         </tr>
      );
   };

   return (
      <div id={"majic-proprio-bnd"}>
         {asData ? (
            <Fragment>
               <div className={"section section-data card ueThemeBackground ueColorBase border-0"}>
                  <div className="card-body">
                     <div className="ue-detail-parcelle-section-title" style={{ fontWeight: "bold" }}>
                        Propriétaire Détails
                     </div>
                     <table
                        className="table table-condensed ue-table-data"
                        style={{ width: "100%", fontSize: "0.65rem" }}
                     >
                        <thead
                           style={{
                              wordBreak: "initial",
                              color: "#70989A",
                           }}
                        >
                           <tr>
                              <th>N°</th>
                              <th>Nom</th>
                              <th>Date</th>
                              <th className={"text-center"}>Surface</th>
                           </tr>
                        </thead>
                        <tbody>
                           {items
                              ? items.map((item, index) => {
                                   return renderItems(item, index);
                                })
                              : null}
                        </tbody>
                     </table>
                  </div>
               </div>
            </Fragment>
         ) : isLoading ? (
            <div className="text-center my-2">
               <Spinner animation="border" size={"sm"} />
            </div>
         ) : (
            <div></div>
         )}
         <div style={{ height: "2rem" }}></div>
      </div>
   );
};

const mapStateToProps = (state) => {
   return {
      detailKeyPar: state.LeftPanelReducer.detailKeyPar,
   };
};

const mapDispatchTProps = (dispatch) => {
   return {};
};
export default connect(mapStateToProps, mapDispatchTProps)(DataProprioBND);
